import CopyValue from "../../../components/CopyValue";
import { H2 } from "../../../components/Headers";
import { Box } from "theme-ui";
import { useOrganizations } from "../../../contexts/UserProvider";
import { useTranslations } from "../../../contexts/Translation";
import { InfoMessage } from "../../../components/InfoMessage/Index";
import { Tip } from "../../../components/Tip/Index";


const InviteSection = () => {
  const { currentOrganization } = useOrganizations();
  const t = useTranslations('userManagementForm');

  return (
    <Box>
      <H2>{t('inviteUsersTitle')}</H2>
      <Tip>{t('inviteUsersDescription')}</Tip>
      <CopyValue value={`${process.env.REACT_APP_SELF}/join/${currentOrganization}`} />
      <InfoMessage type='warning'>{t('inviteUsersInfo')}</InfoMessage>
    </Box>
  );
};

export default InviteSection;